module.exports = __webpack_public_path__ + "img/start_logo_1.39d15a19.jpg";